import { ITenantUser } from '@user/store/users'

export const userHasOpenRecords = (user: ITenantUser): boolean => {
  if (!user) return false

  if (
    user.isActive &&
    ((user.openLeadCount && user.openLeadCount > 0) ||
      (user.openOppCount && user.openOppCount > 0))
  ) {
    return true
  }

  return false
}
